import { useState, useEffect } from 'react';
import DeviceOrientation from '../ressources/DeviceOrientation';
import Content from './Content';
//import Content from './ContentWithCS';
import './Layout.css';

export default function Layout({ token }) {
    // Device orientation overlay deactivated
    return <Content token={token} />;
}
